module.exports = __webpack_public_path__ + "img/1 (14).ace4d5d0.jpg";